export default __webpack_public_path__ + "static/logo-b5cd79bbda3a2299102e3cfc06454eb7.png";